import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 bg-warmBrown text-cream/60 text-center text-sm" data-id="element-36">
        <p data-id="element-37">
          © {new Date().getFullYear()} Gato de Depto. Feliz. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-38">
          Este sitio no es parte de Facebook ni de Meta Inc.
        </p>
        <div className="mt-4 flex items-center justify-center gap-4" data-id="element-39">
          <button onClick={() => setActiveModal('privacy')} className="underline underline-offset-2 hover:text-cream transition-colors cursor-pointer" data-id="element-40">
            Política de Privacidad
          </button>
          <span className="text-cream/30" data-id="element-41">|</span>
          <button onClick={() => setActiveModal('terms')} className="underline underline-offset-2 hover:text-cream transition-colors cursor-pointer" data-id="element-42">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-43">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-44">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-cream text-warmBrown rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-45">
              <div className="flex items-center justify-between p-6 border-b border-warmBrown/10" data-id="element-46">
                <h2 className="text-2xl font-heading" data-id="element-47">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-warmBrown/10 transition-colors cursor-pointer" aria-label="Cerrar" data-id="element-48">
                  <XIcon size={20} data-id="element-49" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto text-left text-warmBrown/80 leading-relaxed space-y-4" data-id="element-50">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-51" /> : <TermsContent data-id="element-52" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-warmBrown/50" data-id="element-53">
        Última actualización: Abril 2026
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-54">
        1. Información que recopilamos
      </h3>
      <p data-id="element-55">
        Al adquirir la guía "Gato de Depto. Feliz", recopilamos únicamente la
        información necesaria para procesar tu compra: nombre, dirección de
        correo electrónico y datos de pago procesados de forma segura a través
        de Mercado Pago.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-56">
        2. Uso de la información
      </h3>
      <p data-id="element-57">
        Tu información personal se utiliza exclusivamente para: enviar la guía a
        tu correo electrónico, brindarte soporte post-compra y enviarte
        actualizaciones relacionadas con el producto (solo si diste tu
        consentimiento).
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-58">
        3. Protección de datos
      </h3>
      <p data-id="element-59">
        No compartimos, vendemos ni cedemos tu información personal a terceros.
        Los pagos son procesados de forma segura por Mercado Pago y no
        almacenamos datos de tarjetas de crédito o débito.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-60">4. Cookies</h3>
      <p data-id="element-61">
        Este sitio puede utilizar cookies con fines analíticos para mejorar la
        experiencia del usuario. No se utilizan cookies con fines publicitarios
        de terceros.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-62">5. Tus derechos</h3>
      <p data-id="element-63">
        Podés solicitar la eliminación de tus datos personales en cualquier
        momento escribiéndonos por correo electrónico. Responderemos a tu
        solicitud en un plazo máximo de 30 días.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-warmBrown/50" data-id="element-64">
        Última actualización: Abril 2026
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-65">1. Producto digital</h3>
      <p data-id="element-66">
        "Gato de Depto. Feliz" es un producto digital (guía en formato
        PDF/digital) que se entrega de forma inmediata a tu correo electrónico
        tras confirmar el pago.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-67">2. Uso personal</h3>
      <p data-id="element-68">
        La guía es para uso personal y no puede ser redistribuida, revendida,
        compartida públicamente ni reproducida total o parcialmente sin
        autorización previa por escrito.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-69">
        3. Política de reembolso
      </h3>
      <p data-id="element-70">
        Dado que se trata de un producto digital de entrega inmediata, no se
        ofrecen reembolsos una vez realizada la compra y entregado el producto.
        Si tenés algún problema con la descarga o acceso, contactanos y te
        ayudaremos a resolverlo.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-71">4. Resultados</h3>
      <p data-id="element-72">
        Los resultados pueden variar según cada gato y su entorno. La guía
        ofrece recomendaciones basadas en experiencia y buenas prácticas, pero
        no garantiza resultados específicos. Ante problemas de salud o
        comportamiento severos, consultá con un veterinario.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-73">
        5. Propiedad intelectual
      </h3>
      <p data-id="element-74">
        Todo el contenido de esta guía y de este sitio web está protegido por
        derechos de autor. Queda prohibida su reproducción sin autorización
        expresa.
      </p>

      <h3 className="text-lg font-bold text-warmBrown" data-id="element-75">6. Modificaciones</h3>
      <p data-id="element-76">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas desde su publicación en este
        sitio.
      </p>
    </>;
}